export default __webpack_public_path__ + "static/media/profile.a44f632a.jpeg";